<template>
  <a-layout class="ticket-list">
    <TitleBreadcrumb />
    <div class="content-base container">
      <a-card class="ticket-list-card">
        <a-row type="flex" justify="center" :gutter="[16, 16]">
          <a-col :xs="24">
            <a-collapse>
              <a-collapse-panel key="1" :header="labels.advanceSearch">
                <div slot="extra" class="tag-d-flex">
                  <div
                    v-for="key in Object.keys(filters)"
                    :key="key"
                    class="tag-d-flex"
                  >
                    <a-tag
                      color="green"
                      v-if="key === 'dateRange'"
                      closable
                      @close="deleteFilter(key, true)"
                    >
                      {{ filters[key][0] }} - {{ filters[key][1] }}
                    </a-tag>
                    <a-tag
                      v-else
                      closable
                      @close="deleteFilter(key)"
                      color="green"
                    >
                      {{ filters[key] }}
                    </a-tag>
                  </div>
                  <a-tag
                    color="green"
                    v-if="search"
                    closable
                    @close="handleSearch('')"
                  >
                    {{ search }}
                  </a-tag>
                </div>
                <a-row type="flex" justify="center" :gutter="[16, 16]">
                  <a-col :xs="24" :md="8">
                    <div class="calendar-range-start-end">
                      <a-date-picker
                        v-model="startValue"
                        format="YYYY-MM-DD"
                        :placeholder="labels.startDate"
                      />
                      <a-date-picker
                        v-model="endValue"
                        format="YYYY-MM-DD"
                        :placeholder="labels.endDate"
                      />
                    </div>
                  </a-col>
                  <a-col :xs="24" :md="8">
                    <a-input-search
                      :placeholder="labels.placeholderSearch"
                      style="width: 100%"
                      @search="handleSearch"
                      v-model="search"
                      allowClear
                    />
                  </a-col>
                  <a-col :xs="24" :md="8">
                    <a-button
                      type="primary"
                      @click="
                        handleSearchWithFilters(
                          'wonTickets',
                          'Tickets Ganadores'
                        )
                      "
                      block
                      class="winner-tickets"
                    >
                      {{ labels.showWinningTickets }}
                    </a-button>
                  </a-col>
                </a-row>
              </a-collapse-panel>
            </a-collapse>
          </a-col>
          <a-col :xs="24">
            <a-divider
              orientation="center"
              type="horizontal"
              :style="{ marginBottom: 0 }"
            />
          </a-col>
        </a-row>
        <a-row type="flex" justify="center" :gutter="[16, 16]">
          <a-col :xs="24">
            <StandardTable
              class="table-base"
              ref="standardTable"
              :fetchService="fetchTickets"
              :columns="columns"
              :locale="locale"
              :handleShowTotal="handleShowTotal"
              :scroll="{ x: isMobile ? true : false }"
              :rowKey="'number'"
              :paginationType="isMobile ? 'arrows' : 'numbers'"
              :customRow="handleCustomRow"
            />
          </a-col>
        </a-row>
      </a-card>
    </div>
  </a-layout>
</template>
<script>
import { mapActions, mapState } from "vuex";
import accounting from "accounting";
import TitleBreadcrumb from "@/components/layout/client/TitleBreadcrumb.vue";
import loadingMixin from "@/mixins/loadingMixin";
import { pageTitle } from "@/utils/utils";
import labels from "@/utils/labels";
import StandardTable from "@/components/core/table/StandardTable.vue";
import { DATE_FORMAT } from "../../../utils/utils";
import { mapGetters } from "vuex/dist/vuex.common.js";
export default {
  components: { TitleBreadcrumb, StandardTable },
  name: "TicketList",
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(labels.ticketList.subtitle),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.ticketList.subtitle,
      },
    ],
  },
  data() {
    return {
      labels: labels.ticketList,
      search: "",
      loading: false,
      activeRow: null,
      filters: {},
      startValue: null,
      endValue: null,
      cancelling: false,
    };
  },
  created() {
    if (this.cancelTicketTimeOut === null) {
      this.getCancelTicketTimeOutConfig();
    }
  },
  methods: {
    ...mapActions("orders", ["fetchTickets", "cancelTicket"]),
    ...mapActions("systemConfig", ["getCancelTicketTimeOutConfig"]),
    handleReloadTable() {
      let filtersTable = this.$refs.standardTable.filters;
      let result = { ...filtersTable };
      this.$refs.standardTable.handleFilters(result);
    },
    handleShowTotal(total, range) {
      return `${range[0]}-${range[1]} de ${total}`;
    },
    handleSearch(search) {
      this.search = search;
      this.$refs.standardTable.handleSearch(search);
    },
    handleSearchWithFilters(type, value) {
      this.$delete(this.filters, type);
      this.$delete(this.$refs.standardTable.filters, type);
      if (type === "dateRange" && value.length > 0) {
        this.$set(this.filters, "dateRange", []);
        this.filters.dateRange.push(value[0].format("YYYY-MM-DD"));
        this.filters.dateRange.push(value[1].format("YYYY-MM-DD"));
      } else {
        this.$set(this.filters, type, value);
      }
      this.$refs.standardTable.handleSearchWithFilters(
        this.search,
        this.filters
      );
    },
    deleteFilter(value, deleteAll = false) {
      if (value === "dateRange" && deleteAll) {
        this.startValue = null;
        this.endValue = null;
      }
      this.$delete(this.filters, value);
      this.$delete(this.$refs.standardTable.filters, value);
      this.$refs.standardTable.handleSearchWithFilters(
        this.search,
        this.filters
      );
    },
    handleConfirmCancellation(record) {
      this.$confirm({
        title: this.labels.confirmCancellation.title,
        // text to html
        content: () => (
          <div>
            {this.labels.confirmCancellation.content.replace(
              "{code}",
              record.number
            )}
            <br />
            <br />
            <b>{this.labels.confirmCancellation.note}</b>
            <br />
            <ul>
              <li>{this.labels.confirmCancellation.note1}</li>
              <li>
                {this.labels.confirmCancellation.note2.replace(
                  "{count}",
                  this.cancelTicketTimeOut
                )}
              </li>
            </ul>
          </div>
        ),
        okText: this.labels.confirmCancellation.okText,
        okType: "danger",
        icon: "close-circle",
        cancelText: this.labels.confirmCancellation.cancelText,
        okButtonProps: {
          loading: this.cancelling,
          disabled: this.cancelling,
        },
        onOk: async () => {
          this.handleCancellation(record);
        },
      });
    },
    async handleCancellation(record) {
      if (this.cancelling) return;

      this.cancelling = true;
      try {
        await this.cancelTicket(record.number);
        this.$message.success(
          this.labels.confirmCancellation.successCancellation
        );
        this.handleReloadTable();
        this.checkSession();
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message ||
            this.labels.confirmCancellation.errorCancellation
        );
      } finally {
        this.cancelling = false;
      }
    },
    handleCustomRow(_, index) {
      return {
        on: {
          click: () => {
            this.activeRow = this.activeRow === index ? null : index;
          },
        },
      };
    },
  },
  watch: {
    startValue(val) {
      if (val && this.endValue) {
        this.handleSearchWithFilters("dateRange", [val, this.endValue]);
      } else {
        this.deleteFilter("dateRange");
      }
    },
    endValue(val) {
      if (this.startValue && val) {
        this.handleSearchWithFilters("dateRange", [this.startValue, val]);
      } else {
        this.deleteFilter("dateRange");
      }
    },
  },
  computed: {
    ...mapState("layout", ["screenWidth"]),
    ...mapGetters({
      cancelTicketTimeOut: "systemConfig/getCancelTicketTimeOut",
    }),
    locale() {
      return {
        emptyText: this.labels.table.emptyText,
      };
    },
    columns() {
      return [
        {
          title: this.labels.table.columns.date,
          dataIndex: "date",
          key: "date",
          sorter: true,
          hidden: this.isMobile,
          customRender: (text) => {
            return this.$moment(text).format(DATE_FORMAT.MOMENT_DATE_TIME);
          },
        },
        {
          title: this.labels.table.columns.code,
          dataIndex: "number",
          key: "number",
          sorter: true,
          hidden: this.isMobile,
        },
        {
          title: this.labels.table.columns.totalAmount,
          dataIndex: "total_amount",
          key: "total_amount",
          sorter: true,
          hidden: this.isMobile,
          customRender: (text) => {
            return accounting.formatNumber(text || 0, 2, ",", ".");
          },
        },
        {
          title: this.labels.table.columns.wonTotalAmount,
          dataIndex: "won_total_amount",
          key: "won_total_amount",
          sorter: true,
          hidden: this.isMobile,
          customRender: (text) => {
            return accounting.formatNumber(text || 0, 2, ",", ".");
          },
        },
        {
          title: this.labels.table.columns.status.title,
          dataIndex: "status",
          key: "status",
          sorter: true,
          hidden: this.isMobile,
          customRender: (text) => {
            return (
              <a-tag color={this.statusColor(text)}>
                {this.statusText(text)}
              </a-tag>
            );
          },
        },
        {
          title: this.labels.table.columns.action.title,
          dataIndex: "action",
          key: "action",
          width: "120px",
          align: "center",
          hidden: this.isMobile,
          customRender: (_, record) => {
            return (
              <div class="action-buttons">
                <router-link
                  to={{
                    name: "ticket-view",
                    params: { code: record.number },
                  }}
                  title={this.labels.table.columns.action.view}
                >
                  <a-button icon="eye" class="action-button-view" />
                </router-link>
                {record?.is_cancellable ? <a-divider type="vertical" /> : null}
                {record?.is_cancellable ? (
                  <a-button
                    icon="close-circle"
                    class="action-button-cancel"
                    title={this.labels.table.columns.action.cancel}
                    onClick={() => this.handleConfirmCancellation(record)}
                    loading={this.loading}
                    disabled={this.loading}
                    type="danger"
                  />
                ) : null}
              </div>
            );
          },
        },
        {
          title: this.labels.table.columns.tickets,
          dataIndex: "tickets",
          key: "tickets",
          sorter: false,
          hidden: !this.isMobile,
          customRender: (_, record, index) => {
            // Card item design
            const color = this.statusColor(record.status?.toLowerCase());
            return (
              <div class="list-item">
                <div class="list-item-head">
                  <div
                    class="list-item-head-header"
                    style={{ borderColor: color }}
                  >
                    <span>
                      {this.$options.filters.ucwords(
                        this.$moment(record.date).format(
                          DATE_FORMAT.MOMENT_DAY_MONTH
                        )
                      )}
                    </span>
                    <small>
                      {this.$moment(record.date)
                        .format(DATE_FORMAT.MOMENT_TIME)
                        .toUpperCase()}
                    </small>
                  </div>
                  <div class="list-item-head-content">
                    <div class="list-item-head-content-number">
                      <span>{record.number}</span>
                    </div>
                    <div class="list-item-head-content-status">
                      <a-tag color={this.statusColor(record.status)}>
                        {this.statusText(record.status)}
                      </a-tag>
                    </div>
                  </div>
                  <div class="list-item-head-footer">
                    <div class="list-item-head-footer-amount">
                      <span>
                        {accounting.formatNumber(
                          record.total_amount,
                          2,
                          ",",
                          "."
                        )}
                      </span>
                    </div>
                    {record?.won_total_amount ? (
                      <div class="list-item-head-footer-amount">
                        <span class="success">
                          <font-awesome-icon
                            icon={["fas", "hand-holding-dollar"]}
                            class="anticon"
                          />
                          {accounting.formatNumber(
                            record.won_total_amount,
                            2,
                            ",",
                            "."
                          )}
                        </span>
                      </div>
                    ) : null}
                  </div>
                </div>
                {this.activeRow === index && (
                  <div class="list-item-actions">
                    <a-button-group>
                      <router-link
                        class="view-button ant-btn ant-btn-primary ant-btn-block"
                        to={{
                          name: "ticket-view",
                          params: { code: record.number },
                        }}
                        title={this.labels.table.columns.action.view}
                      >
                        {this.labels.table.columns.action.view}
                      </router-link>
                      {record?.is_cancellable ? (
                        <a-button
                          class="cancel-button ant-btn ant-btn-danger"
                          title={this.labels.table.columns.action.cancel}
                          onClick={() => this.handleConfirmCancellation(record)}
                          type="danger"
                          loading={this.loading}
                          disabled={this.loading}
                          block
                        >
                          {this.labels.table.columns.action.cancel}
                        </a-button>
                      ) : null}
                    </a-button-group>
                  </div>
                )}
              </div>
            );
          },
        },
      ].filter((column) => !column.hidden);
    },
    isMobile() {
      return this.screenWidth < 768;
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.ticket-list {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  @media screen and (max-width: $screen-mobile) {
    max-width: 100% !important;
  }
  .content-base {
    padding-top: 60px;
    @media screen and (max-width: $screen-mobile) {
      max-width: 100% !important;
      padding-top: 14px;
    }
  }
  &-card {
    background-color: var(--card-shop-bg);
    border-color: var(--card-shop-shadow);
    border-radius: 8px;
    padding: 1.125rem;
    @media screen and (max-width: $screen-mobile) {
      padding: 2.125rem 1rem;
      width: 100%;
    }
    .ant-input {
      border: 1px solid var(--text-active) !important;
      color: var(--text) !important;
      font-family: "Exo 2", sans-serif !important;
      background-color: transparent;
    }
    .ant-input-search-icon {
      color: var(--text) !important;
      transition: all 0.5s ease;
      :hover {
        color: var(--text-active) !important;
        transition: all 0.5s ease;
      }
    }
    .ant-input-clear-icon {
      color: var(--text) !important;
      transition: all 0.5s ease;
      :hover {
        color: var(--danger) !important;
        transition: all 0.5s ease;
      }
    }
    .ant-table {
      &:hover {
        transition: 0.5s ease;
        background: unset;
      }
      tr.ant-table-row:hover {
        transition: 0.5s ease;
        background: var(--table-hover) !important;
      }
      tr:nth-child(2n) {
        transition: 0.5s ease;
        background: var(--table-striped) !important;
      }
      tr.table-row-disabled,
      tr.table-row-disabled:hover {
        color: var(--table-disabled) !important;
        background: var(--table-disabled) !important;
        font-weight: 600;
      }
      .ant-table-tbody > tr.ant-table-row:hover > td {
        transition: 0.5s ease;
        background: none !important;
      }
      &-tbody,
      &-thead {
        color: var(--text) !important;
        tr {
          th {
            color: var(--text) !important;
            background-color: transparent !important;
          }
        }
      }
      &-footer {
        background: transparent;
      }
      .action-button-view {
        color: var(--btn-text-secondary);
        border-color: var(--btn-bc-secondary);
        background-color: var(--btn-bg-secondary);
        transition: all 0.5s ease;
        &:hover {
          color: var(--btn-text-secondary);
          border-color: var(--btn-bc-secondary);
          background-color: var(--btn-bg-secondary);
          transition: all 0.5s ease;
        }
      }
      .ant-table-placeholder {
        background: var(--card-bg);
        color: var(--text);
        border-radius: 0;
      }
      @media screen and (max-width: $screen-mobile) {
        &-small {
          border: none;
        }
        &-body {
          margin: 0 1px;
        }
      }
    }
    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
      color: var(--btn-text-secondary) !important;
      background-color: var(--btn-bg-secondary) !important;
      border-color: var(--btn-bc-secondary) !important;
    }
    .ant-table-pagination.mini {
      .ant-pagination-prev .ant-pagination-item-link,
      .ant-pagination-next .ant-pagination-item-link {
        background-color: transparent !important;
        border-color: none !important;
        color: var(--text) !important;
      }
    }
    .ant-pagination-item {
      color: var(--btn-text-secondary) !important;
      background-color: var(--btn-bg-secondary) !important;
      border-color: var(--btn-bc-secondary) !important;
      a {
        color: var(--btn-text-secondary) !important;
      }
      &-active {
        color: var(--btn-text-primary) !important;
        background-color: var(--btn-bg-primary) !important;
        border-color: var(--btn-bc-primary) !important;
        a {
          color: var(--btn-text-primary) !important;
        }
      }
    }
    .ant-pagination {
      color: var(--text) !important;
    }

    .tag-d-flex {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
    }
  }
  .list-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    &-head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 6px;
      &-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2px;
        max-width: 25%;
        width: 25%;
        border-right: 4px solid color(border);
        .success {
          color: var(--success);
        }
        .warning {
          color: var(--warning);
        }
        .danger {
          color: var(--danger);
        }
        span {
          font-size: 14px;
          font-weight: 600;
        }
        small {
          font-size: 12px;
          font-weight: 400;
          padding-right: 4px;
        }
      }
      &-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 2px;
        max-width: 30%;
        width: 30%;
        overflow: hidden;
        &-number {
          span {
            font-size: 16px;
            font-weight: 600;
            text-overflow: ellipsis;
          }
        }
        &-status {
          span {
            font-size: 12px;
            font-weight: 400;
            text-overflow: ellipsis;
          }
        }
      }
      &-footer {
        max-width: 45%;
        width: 45%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: right;
        gap: 2px;
        &-amount {
          width: 100%;
          span {
            width: 100%;
            font-size: 14px;
            font-weight: 600;
            &.success {
              color: var(--success);
            }
            .anticon {
              margin-right: 6px;
            }
          }
          &:first-child {
            span {
              font-size: 16px;
            }
          }
        }
      }
    }
    &-actions {
      width: 100%;
      margin-top: 10px;
      .ant-btn-group {
        width: 100%;
        .more-info-button,
        .view-button,
        .cancel-button {
          width: 100%;
        }
        .more-info-button {
          color: var(--btn-text-secondary);
          border-color: var(--btn-bc-secondary);
          border-right-color: var(--btn-bc-secondary);
          background-color: var(--btn-bg-secondary);
          &:active,
          &:focus,
          &:hover {
            color: var(--btn-text-secondary);
            border-color: var(--btn-bc-secondary);
            border-right-color: var(--btn-bc-secondary);
            background-color: var(--btn-bg-secondary);
          }
        }
        .view-button {
          color: var(--btn-text-primary);
          border-color: var(--btn-bc-primary);
          background-color: var(--btn-bg-primary);
          &:active,
          &:focus,
          &:hover {
            color: var(--btn-text-primary);
            border-color: var(--btn-bc-primary);
            background-color: var(--btn-bg-primary);
          }
        }
      }
    }
  }

  .ant-collapse {
    background-color: var(--card-bg);
    .ant-collapse-header {
      color: var(--btn-text-secondary);
      display: flex;
      gap: 10px;
    }
    .ant-collapse-content {
      background-color: var(--card-bg);
      color: var(--btn-text-secondary);
    }
    .ant-calendar-picker-icon,
    .ant-calendar-range-picker-separator {
      color: var(--text);
    }
    .calendar-range-start-end {
      > span:nth-child(1) {
        width: 50%;
        input {
          border-radius: 5px 0 0 5px;
          border-right: none !important;
        }
      }

      > span:nth-child(2) {
        width: 50%;
        input {
          border-radius: 0 5px 5px 0;
          border-left: none !important;
        }
      }
    }
    .winner-tickets {
      background-color: var(--btn-bc-primary);
      border-color: var(--btn-bc-primary);
      color: var(--btn-text-primary);
    }
  }
}
</style>
